module.exports = __webpack_public_path__ + "img/icon_product_3.b189b2d6.svg";